export var PLUGIN_NAME = 'web-vitals-browser';
export var WEB_VITALS_EVENT_NAME = '[Amplitude] Web Vitals';
